<script setup>
import {useTitle} from "@/utils/metadata";
import {pgettext} from "@/utils/translate";
import HpoList from "@/components/hpo/HpoList.vue";

useTitle(pgettext('title', 'Mass Disaster - List'));
</script>

<template>
    <HpoList/>
</template>
